import { render } from "./IndexGarde.vue?vue&type=template&id=f33aa398"
import script from "./IndexGarde.vue?vue&type=script&lang=js"
export * from "./IndexGarde.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__